const devLogMessage = (message, optionalParams) => {
    if (process.env.TARGET_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.log(message, optionalParams ? optionalParams : '');
    }
};
export const SurveyHelper = {
    invokeEvent(event) {
        window._sva?.invokeEvent(event);
        devLogMessage(`The survicate invoke method was triggered for: ${event}`);
    },
    showSurvey(id, options) {
        window._sva?.showSurvey(id, options);
        devLogMessage(`The survicate show survey method was triggered for: ${id}`, options);
    }
};
